// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"500307b3","472":"b86437e7","832":"4f2fa5cc"}[chunkId] + ".chunk.js";
};